<template>
  <div class="not-found">
    <navbar />
    <div class="page-intro page-intro--v2 d-flex justify-content-center align-items-center">
      <div>
        <h1 class="page-intro__title">Página Não Encontrada</h1>
        <p class="page-intro__description">A página que procura não se encontra disponível.</p>
      </div>
    </div>
  </div>
</template>

<script>
  import Navbar from './home/sections/Navbar.vue'

  export default {
    title: '404 Página Não Encontrada',
    components: {
      Navbar
    }
  };
</script>